import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const removeActiveSessions = createAsyncThunk('user/removeActiveSessions', async () => {
	return await AccountService.removeAllActiveSessions();
});
